import * as types from '@/store/mutation-types.js';
import api from '../api/common'

export default {
	getHomeInfos({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getHomeInfos(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //參加學會活動
  joinActivity({commit}, data) {
    return new Promise((resolve, reject) => {
      api.joinActivity(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //学会报名支付结果查询
  getPayResult({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getPayResult(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //学会报名,重新支付
  rePayActivityCost({commit}, data) {
    return new Promise((resolve, reject) => {
      api.rePayActivityCost(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAssociationDetail({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getAssociationDetail(data).then(rs => {
        if(rs['code'] == 200){
          commit(types.SET_ASSOCIATION, JSON.stringify(rs.data))
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  receiptDownload({commit}, data) {
    return new Promise((resolve, reject) => {
      api.receiptDownload(data).then(rs => {
        resolve(rs.data);
      }).catch(error => {
        reject(error)
      })
    })
  },
  certificateDownload({commit}, data) {
    return new Promise((resolve, reject) => {
      api.certificateDownload(data).then(rs => {
        resolve(rs.data);
      }).catch(error => {
        reject(error)
      })
    })
  },
  getArticleList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getArticleList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewArticleList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getNewArticleList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHotArticleList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getHotArticleList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getArticleDetail({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getArticleDetail(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityDetail({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityDetail(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewActivityList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getNewActivityList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityPhotos({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityPhotos(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityPhotoDetail({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityPhotoDetail(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewsList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getNewsList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewsDetail({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getNewsDetail(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNewsCategoryList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getNewsCategoryList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  login({commit}, data) {
    return new Promise((resolve, reject) => {
      api.login(data).then(rs => {
        if(rs['code'] == 200){
          resolve({userInfo: rs.data, token: rs.token, commit});
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserInfo({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getUserInfo(data).then(rs => {
        if(rs['code'] == 200){
          var userInfo = rs.data
          if(userInfo && userInfo.clientid && userInfo.doctorno) {
            commit(types.SET_USER_INFO, JSON.stringify(userInfo))
          }
          resolve(userInfo);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({commit}, data) {
    commit(types.SET_TOKEN, null)
    commit(types.SET_USER_INFO, null)
    return new Promise((resolve, reject) => {
      api.logout(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  register({commit}, data) {
    return new Promise((resolve, reject) => {
      api.register(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getVCode({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getVCode(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetPassword({commit}, data) {
    return new Promise((resolve, reject) => {
      api.resetPassword(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatePassword({commit}, data) {
    return new Promise((resolve, reject) => {
      api.updatePassword(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAreaList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getAreaList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMyActivitys({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getMyActivitys(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityInfo({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityInfo(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadImage({commit}, data) {
    return new Promise((resolve, reject) => {
      api.uploadImage(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  joinAssociation({commit}, data) {
    return new Promise((resolve, reject) => {
      api.joinAssociation(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getActivityQuestions({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getActivityQuestions(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  checkActivityAnswer({commit}, data) {
    return new Promise((resolve, reject) => {
      api.checkActivityAnswer(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //学会网站登录协议勾选
  checkedProtocol({commit}, data) {
    return new Promise((resolve, reject) => {
      api.checkedProtocol(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取我的问题卡
  getMyQuestionList({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getMyQuestionList(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取问题卡详情
  queryQuestionBankItems({commit}, data) {
    return new Promise((resolve, reject) => {
      api.queryQuestionBankItems(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取问题答案
  getQuestionAnswer({commit}, data) {
    return new Promise((resolve, reject) => {
      api.getQuestionAnswer(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetLearnRecord({commit}, data) {
    return new Promise((resolve, reject) => {
      api.resetLearnRecord(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  queryCompletedLearnRecord({commit}, data) {
    return new Promise((resolve, reject) => {
      api.queryCompletedLearnRecord(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  completeLearn({commit}, data) {
    return new Promise((resolve, reject) => {
      api.completeLearn(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //记录复习进度
  recordSchedule({commit}, data) {
    return new Promise((resolve, reject) => {
      api.recordSchedule(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //恢复题目标识,错题,忽略题等
  recoverMark({commit}, data) {
    return new Promise((resolve, reject) => {
      api.recoverMark(data).then(rs => {
        if(rs['code'] == 200){
          resolve(rs.data);
        } else {
          reject(rs.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //保存答题卡选中的答案
  saveAnswer({commit}, data) {
    return new Promise((resolve, reject) => {
      commit(types.SET_PRE_ANSWERLIST, JSON.stringify(data))
      resolve(true)
    })
  },
}
